import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAPI, reinitialiseAPI } from 'store/apiReducer';
import SimpleTable from 'components/Commun/Table/SimpleTable';
import { Container, IndicateurEtapes, Row, Col } from '@si-armes/dsfr-react';
import { useParams } from 'react-router';
import SignalerErreurEtape1 from './components/etape1/SignalerErreurEtape1';
import SignalerErreurEtape2 from './components/etape2/SignalerErreurEtape2';
import SignalerErreurEtape3 from './components/etape3/SignalerErreurEtape3';
import usagerClientReducer from '../../../../store/usagerReducer';
import {
    API_GET_ARME_POUR_ERREUR_BY_UNIQUID,
    CONTEXT_GET_ARME_POUR_ERREUR_BY_UNIQUID,
} from '../../../../constants/apiUrls.constants';
import { definirComplement } from '../../../../store/titreReducer';

const ArmeSignalerErreur = () => {
    const dispatch = useDispatch();

    const { isLoading, data: arme } = useSelector((state) => state.armes.signalerErreur.recuperer);

    const [etapeActive, setEtapeActive] = useState(1);
    const [armeRecuperer, setArmeRecuperer] = useState([]);
    const { uuidArme } = useParams();
    const [signalerArmeData, setSignalerArmeData] = useState({ typeErreur: null });

    useEffect(() => {
        dispatch(reinitialiseAPI(CONTEXT_GET_ARME_POUR_ERREUR_BY_UNIQUID));
        return () => {
            dispatch(reinitialiseAPI(CONTEXT_GET_ARME_POUR_ERREUR_BY_UNIQUID));
        };
    }, []);

    useEffect(() => {
        if (!Array.isArray(arme)) {
            dispatch(
                getAPI(
                    usagerClientReducer,
                    API_GET_ARME_POUR_ERREUR_BY_UNIQUID + uuidArme,
                    CONTEXT_GET_ARME_POUR_ERREUR_BY_UNIQUID,
                ),
            );
        }
    }, []);

    useEffect(() => {
        if (arme !== null && Array.isArray(Object.values(arme))) {
            const { gdrRga, numEncodage, numeroCarcasse, uniquid } = arme;
            const {
                type,
                marque,
                modele,
                canonUn,
                canonDeux,
                classementFrancais,
                classementEuropeen,
            } = gdrRga;
            const liste = [];
            setSignalerArmeData({ uuidArme: uniquid });

            liste.push([
                numEncodage,
                numeroCarcasse,
                type,
                marque,
                modele,
                canonUn.libelleCalibre,
                canonDeux ? canonDeux.libelleCalibre : ' - ',
                classementFrancais ?? classementEuropeen,
            ]);

            setArmeRecuperer(liste);
        }
    }, [arme]);

    const tableauConfigHeader = [
        "Numéro d'encodage",
        'Numéro de série',
        'Type',
        'Marque',
        'Modèle',
        'Calibre Canon 1',
        'Calibre Canon 2',
        'Classement',
    ];

    const updateSignalerArmeData = (object) => {
        Object.entries(object).map(([key, value]) =>
            setSignalerArmeData((prevState) => ({
                ...prevState,
                [key]: value,
            })),
        );
    };

    const resetSignalerArmeData = (typeErreur) => {
        setSignalerArmeData({
            uuidArme: arme.uniquid,
            typeErreur,
        });
    };

    const etapes = [
        { key: 1, titre: "Identification de l'erreur" },
        { key: 2, titre: 'Correction' },
        { key: 3, titre: 'Recapitulatif et validation' },
    ];

    React.useEffect(() => {
        if (etapeActive > 0) {
            dispatch(definirComplement(`étape ${etapeActive}/3`));
        }
    }, [etapeActive]);
    return (
        <Container fluid={false}>
            <Row>
                <Col col={12}>
                    <h1>Signaler une erreur</h1>
                </Col>
            </Row>
            <Row>
                <Col col={12}>
                    <IndicateurEtapes
                        etapeEnCours={etapeActive}
                        nombreEtapes={3}
                        titreEtapeEnCours={etapes.find((etape) => etape.key === etapeActive).titre}
                        titreProchaineEtape={
                            etapeActive < 3
                                ? etapes.find((etape) => etape.key === etapeActive + 1).titre
                                : null
                        }
                    />
                </Col>
            </Row>

            <Row>
                <Col col={12}>
                    <h2>Arme sélectionnée</h2>
                </Col>
            </Row>

            <Row>
                <Col col={12}>
                    <SimpleTable
                        isLoading={isLoading}
                        entete={tableauConfigHeader}
                        donnees={armeRecuperer}
                    />
                </Col>
            </Row>

            {etapeActive === 1 ? (
                <SignalerErreurEtape1
                    etapeSuivante={() => {
                        setEtapeActive(2);
                    }}
                    resetSignalerArmeData={resetSignalerArmeData}
                    signalerArmeData={signalerArmeData}
                />
            ) : null}

            {etapeActive === 2 ? (
                <SignalerErreurEtape2
                    etapePrecedente={() => {
                        setEtapeActive(1);
                    }}
                    etapeSuivante={() => {
                        setEtapeActive(3);
                    }}
                    signalerArmeData={signalerArmeData}
                    handleUpdateSignalerArmeData={updateSignalerArmeData}
                />
            ) : null}

            {etapeActive === 3 ? (
                <SignalerErreurEtape3
                    etapePrecedente={() => {
                        setEtapeActive(2);
                    }}
                    signalerArmeData={signalerArmeData}
                    tableauConfigHeader={tableauConfigHeader}
                />
            ) : null}
        </Container>
    );
};

export default ArmeSignalerErreur;
